import { useState } from "react";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Icon } from "@iconify/react";
import crystalfilter from "../assets/images/crystal-filter-1.jpeg";
import img from "../assets/images/character-images/Layer 1 copy 3.png";
import filter from "../assets/images/crystal-filter.svg";

export default function Banner() {
  return (
    <div className="text-white relative banner_div h-[100vh] lg:h-[150vh] pt-[100px]">
      <img class="crystal-filter-home" src={filter} alt=""></img>
      <div class="fire-bg h-[80%] z-[3] w-full absolute bottom-0 bg-bottom bg-[center]"></div>
      <img
        class="generals-center absolute right-0 top-[290px] lg:top-0 lg:w-[70%] z-[2]"
        src={img}
        alt=""
      />

      <div class="top-left w-[100%] mx-auto xl:w-[40%] lg:mx-0 absolute z-[9] left-[50%] translate-x-[-50%] lg:translate-x-[-28%] lg:left-[20%] top-[11%] lg:top-[18%]">
        <div class="content-top text-center lg:text-start tracking-[100%] leading-[130%] text-[45px] md:text-[70px] xl:text-[100px]">
          {/* your
          <br />
          destiny is
          <br />
          waiting. */}
          The ultimate survival game on the blockchain
        </div>
        <div class="des lg:flex items-center gap-3 w-[100%] absolute mt-[400px] lg:mt-3">
          <a
            href="#"
            className="btn-play texture-bg flex items-center justify-center w-[250px] mb-[30px] lg:mb-[unset] mx-auto xl:w-[unset] text-[16px] xl:text-[20px] py-[10px] px-[20px] xl:py-[15px] xl:px-[30px]"
          >
            <span> PLAY NOW</span>
            <span>
              <Icon icon="fluent-mdl2:game" className="text-[25px]" />
            </span>
          </a>
          <div class="des-top text-center text-[16px] lg:text-[20px]">
            {/* Become part of The Red Village <br />
            world! The Blood Queen is calling.
            <br />
            Will you answer? */}
            Explore the world, survive and crypto.
          </div>
        </div>
      </div>
      <div className="relative isolate px-6 pt-14 lg:px-8">
        {/* <div className="crystal">
          <img src={crystalfilter} alt="" />
        </div> */}
        {/* <div className="mr-auto md:ms-[120px] max-w-2xl py-0 sm:py-5 lg:py-5">
          <div className="text-center sm:text-start h-[90vh] md:h-[unset]">
            <h1 className="text-4xl hidden md:block font-bold tracking-tight sm:text-6xl">
              YOUR <br />
              DESTINY IS <br /> WAITING.
            </h1>
            <h1 className="text-5xl md:hidden font-bold tracking-tight sm:text-6xl">
              YOUR DESTINY <br /> IS WAITING.
            </h1>

            <div className=" absolute bottom-0 left-1/2 sm:left-[unset] transform -translate-x-1/2 sm:static sm:translate-x-[unset] sm:flex items-center sm:mt-10">
              <div className="md:flex items-center justify-center mb-0 gap-x-6">
                <a
                  href="#"
                  className="flex items-center mb-6 md:mb-[unset] gap-3 w-[300px] md:w-[unset] mx-auto justify-center rounded-full tracking-[3px] px-6 md:px-8 py-3 md:py-4 text-center text-[22px] font-semibold text-white shadow-sm  blur-background"
                >
                  <span> PLAY NOW</span>
                  <span>
                    <Icon icon="fluent-mdl2:game" className="text-[25px]" />
                  </span>
                </a>
                <p className=" text-md leading-5 font-[500]">
                  Become part of The Red Village <br /> world! The Blood Queen
                  is calling. <br /> Will you answer?
                </p>
              </div>
            </div>
          </div>
        </div> */}
        <div
          className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
      </div>
    </div>
  );
}
